import { ReactNode } from 'react'

type Props = {
  dropdownClass?: string
  isDropdown?: boolean
  openDropdown?: boolean
  children: ReactNode
}

export const Container = ({ isDropdown, openDropdown, children, dropdownClass }: Props) => {
  const dropdownClassName = `transition-transform origin-top duration-500 ease-in-out hidden md:flex z-50 w-[390px] ${
    openDropdown ? 'scale-y-100 opacity-100' : 'scale-y-0 opacity-0'
  } max-h-[calc(100vh-200px)] overflow-y-auto flex flex-col rounded-md bg-white shadow-lg ${dropdownClass}`

  const modalClassName =
    'fixed z-40 top-0 bg-white h-screen h-[90dvh] w-screen flex flex-col md:hidden overflow-y-auto pb-[env(safe-area-inset-bottom)] max-sm:pb-[100px]'
  return <div className={isDropdown ? dropdownClassName : modalClassName}>{children}</div>
}
